import React, { useContext } from "react";
import { AppContext } from "../../App";
import Can from "../can/Can";
import { fee } from "../../rbac-consts";
import { default as AdminFeeContainer } from "./admin/FeeContainer";
import { default as ClientFeeContainer } from "./client/FeeContainer";
import { default as PairUnitManagerFeeContainer } from "./pairUnitManager/FeeContainer";

const FeeWrapper = () => {

  const { user } = useContext(AppContext);

  return (
    <>
      <Can
        role={user.roles}
        perform={fee.ADMIN}
        yes={() => (
          <AdminFeeContainer />
        )}
      />
      <Can
        role={user.roles}
        perform={fee.USER}
        yes={() => (
          <ClientFeeContainer />
        )}
      />
      <Can
        role={user.roles}
        perform={fee.PAIR_UNIT_MANAGER}
        yes={() => (
          <PairUnitManagerFeeContainer />
        )}
      />
    </>

  );
};

export default FeeWrapper;